import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { COLORS } from './landingData';

export function HeroSection({ t }) {
  const navigate = useNavigate();

  return (
    <>
      <section style={{ padding: '80px 24px 60px', position: 'relative', overflow: 'hidden' }} data-testid="hero-section">
        <div style={{
          position: 'absolute', top: -100, right: -100, width: 500, height: 500,
          borderRadius: '50%', background: COLORS.sage, opacity: 0.3, filter: 'blur(80px)'
        }} />
        <div style={{
          position: 'absolute', bottom: -80, left: -80, width: 400, height: 400,
          borderRadius: '50%', background: COLORS.accent, opacity: 0.2, filter: 'blur(80px)'
        }} />
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
          <span style={{
            fontSize: 11, letterSpacing: '0.2em', fontWeight: 700, color: COLORS.primary,
            textTransform: 'uppercase', display: 'inline-block', marginBottom: 16,
            background: `${COLORS.sage}80`, padding: '6px 16px', borderRadius: 20,
          }}>
            {t.hero.overline}
          </span>
          <h1 style={{
            fontFamily: 'Outfit, sans-serif', fontSize: 'clamp(32px, 5vw, 60px)',
            fontWeight: 800, lineHeight: 1.05, letterSpacing: '-0.03em',
            color: COLORS.text, marginBottom: 20,
          }}>
            {t.hero.title}<br />
            <span style={{ color: COLORS.secondary }}>{t.hero.titleAccent}</span>
          </h1>
          <p style={{ fontSize: 17, lineHeight: 1.7, color: COLORS.textSecondary, maxWidth: 600, margin: '0 auto 32px' }}>
            {t.hero.subtitle}
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              size="lg"
              onClick={() => navigate('/login')}
              style={{ background: COLORS.primary, color: '#fff', fontWeight: 700, padding: '12px 32px', fontSize: 15, borderRadius: 12 }}
              data-testid="hero-cta-btn"
            >
              {t.hero.cta} <ChevronRight style={{ width: 16, height: 16, marginLeft: 4 }} />
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
              style={{ borderColor: COLORS.border, color: COLORS.text, fontWeight: 600, padding: '12px 28px', fontSize: 15, borderRadius: 12 }}
              data-testid="hero-features-btn"
            >
              {t.hero.ctaSecondary}
            </Button>
          </div>
        </div>
      </section>

      {/* Stats Strip */}
      <section style={{ padding: '40px 24px', borderTop: `1px solid ${COLORS.border}`, borderBottom: `1px solid ${COLORS.border}` }}>
        <div className="landing-stats-grid" style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, textAlign: 'center' }}>
          {t.stats.map((s, i) => (
            <div key={i}>
              <div style={{ fontFamily: 'Outfit, sans-serif', fontSize: 36, fontWeight: 800, color: COLORS.primary, lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: COLORS.textMuted, marginTop: 4, fontWeight: 500 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Feature Marquee */}
      <section style={{ padding: '20px 0', borderTop: `1px solid ${COLORS.border}`, borderBottom: `1px solid ${COLORS.border}`, overflow: 'hidden', background: COLORS.bg }} data-testid="feature-marquee">
        <div className="marquee-track">
          {[0, 1].map(copy => (
            <div className="marquee-content" key={copy} aria-hidden={copy === 1 ? 'true' : undefined}>
              {['Bulk Upload', 'Account Management', 'Month Control', 'Offline Mode', 'Real-time Sync', 'Product Catalog', 'Smart Deliveries', 'Warehouse Management', 'Business Intelligence', 'Medical Rep Tracking', 'Payment Recording', 'Delivery Tracking', 'Reliability Scores', 'Growth Analytics', 'District Summary'].map((f, i) => (
                <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 16, whiteSpace: 'nowrap' }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: COLORS.secondary, display: 'inline-block', flexShrink: 0 }} />
                  <span style={{ fontSize: 14, fontWeight: 600, color: COLORS.textSecondary }}>{f}</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
